import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AlertController, ToastController } from '@ionic/angular';
import { OrderService } from '../../services/order.service';

@Component({
  selector: 'app-glasses-repair-order-detail',
  templateUrl: './glasses-repair-order-detail.page.html',
  styleUrls: ['./glasses-repair-order-detail.page.scss'],
})
export class GlassesRepairOrderDetailPage implements OnInit {

  nr: any = null;
  orderDetail:any = '';
  totalAmount = 0;
  typeText = '';

  constructor(
    private router: Router, 
    private orderService: OrderService, 
    public alertController: AlertController,
    public toastController: ToastController
    ) 
  {}

  ngOnInit() {
    this.nr = this.router.getCurrentNavigation().extras.state.nr;
    if(this.nr){
      this.orderService.getGlassesOrderDetail(this.nr).subscribe( 
        response => {          
          this.orderDetail = response.data;
          if(this.orderDetail.vkleistung1 >= 0 && this.orderDetail.vkleistung1 !== null){
            this.totalAmount = parseFloat(this.orderDetail.vkleistung1);
          }
          if(this.orderDetail.vkleistung2 >= 0 && this.orderDetail.vkleistung2 !== null){
            this.totalAmount = parseFloat(this.orderDetail.vkleistung2) + this.totalAmount;
          }
          if(this.orderDetail.vkleistung3 >= 0 && this.orderDetail.vkleistung3 !== null){
            this.totalAmount = parseFloat(this.orderDetail.vkleistung3) + this.totalAmount;
          }
          if(this.orderDetail.vkfa != '' && this.orderDetail.vkfa !== null){
            this.totalAmount = parseFloat(this.orderDetail.vkfa) + this.totalAmount;
          }
          if(this.orderDetail.vkglr != '' && this.orderDetail.vkglr !== null){
            this.totalAmount = parseFloat(this.orderDetail.vkglr) + this.totalAmount;
          }
          if(this.orderDetail.vkgll != '' && this.orderDetail.vkgll !== null){
            this.totalAmount = this.totalAmount + parseFloat(this.orderDetail.vkgll)
          }
      },
      error => {
        console.log(error);        
      })

    }
  }

  async clickInvoiceRequest() {
    let orderName =  this.orderDetail.brille != '' ? ' ('+this.orderDetail.brille+')': '';
    const alert = await this.alertController.create({
      cssClass: 'invoice-request',
      header: 'Ihre Rechnungsanfrage',
      message: '<p>Gerne stellen wir Ihnen eine Rechnung für Ihren Auftrag Nr. #'+this.nr+orderName+' aus.</p><br><p>Möchten Sie uns zusätzlich noch etwas mitteilen?</p>',
      inputs: [        
        {
          name: 'invoice_message',
          id: 'invoice_message',
          type: 'textarea',
          placeholder: 'Ihre Nachricht an uns.'
        }
      ],
      buttons: [
        {
          text: 'ABBRECHEN',
          role: 'cancel'
        }, {
          text: 'Absenden',
          handler: (alertData) => {
            this.sendInvoiceRequest(alertData.invoice_message);
          }
        }
      ]
    });
    await alert.present();
  }

  sendInvoiceRequest(message){
    const data = {message:message, nr:this.nr, type:'Repaire-Glasses'}
    this.orderService.invoiceRequest(data).subscribe( 
      response => {     
        this.presentToast(response.message); 
    },
    error => {
      this.presentToast(error.error.message);       
    })
  }

  async presentToast(error_msg) {
    const toast = await this.toastController.create({
      message: error_msg,
      duration: 2000
    });
    toast.present();
  }

  backPage(){
    this.router.navigate(['order-listing']);
  }

  backHome(){
    this.router.navigate(['home']);
  }
}